import Vue from "vue";

import App from "./App.vue";

import router from "./router";

import store from "./store";

import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";

import { BootstrapVue } from "bootstrap-vue";

import { VLazyImagePlugin } from "v-lazy-image";

import TextareaAutosize from "vue-textarea-autosize";

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard);

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

Vue.use(BootstrapVue);

Vue.use(VLazyImagePlugin);
Vue.use(TextareaAutosize);

Vue.prototype.vWindow = window;


import VueClipboard from 'vue-clipboard2' 
VueClipboard.config.autoSetContainer = true 
Vue.use(VueClipboard)



Vue.prototype.moment = moment;
Vue.prototype.momentDurationFormatSetup  = momentDurationFormatSetup ;

//CSS
import "./assets/css/vendor/bootstrap/bootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/vendor/golden-ratio/gr.scss";
import "./assets/css/vendor/line-icons/scss/main.scss";
import "./assets/css/vendor/float-labels/float-labels.css";
import "./assets/css/theme.scss";
import "./assets/css/custom.scss";

//config
Vue.config.productionTip = false;

//filters
Vue.filter("capitalize", function (value) {
    if (!value) return "";
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("jsonPretty", function (value) {
    return JSON.stringify(value, null, 2);
});

Vue.filter("currency", function(value) {
  if (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
      return value;
  }
});


//directives
Vue.directive('uppercase', {
  update(el) {
    const sourceValue = el.value;
    const newValue = sourceValue.toUpperCase();

    if (sourceValue !== newValue) {
      el.value = newValue;
      el.dispatchEvent(new Event('input', { bubbles: true }));
    }
  },
});

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
